import React from "react";

interface JsonLdProps {
  /** A schema.org JSON-LD object (or array of objects) to embed in the page. */
  data: Record<string, unknown> | Record<string, unknown>[];
}

/**
 * Renders schema.org structured data as a server-rendered
 * <script type="application/ld+json"> tag so crawlers and AI engines always
 * see it. Use for FAQPage, Article, BreadcrumbList, etc.
 */
export default function JsonLd({ data }: JsonLdProps) {
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
    />
  );
}
